import { render, staticRenderFns } from "./Informacao.vue?vue&type=template&id=b501b8e6&lang=pug"
import script from "./Informacao.vue?vue&type=script&lang=js"
export * from "./Informacao.vue?vue&type=script&lang=js"
import style0 from "./Informacao.vue?vue&type=style&index=0&id=b501b8e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports